var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.999,
    height: 48,
    viewBox: "0 0 47.999 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.165,27.208,48,24,35.165,20.792a11.44,11.44,0,0,1,0,6.416Z",
    fill: "#fddc85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.833,20.792,0,24l12.833,3.208a11.464,11.464,0,0,1,0-6.416Z",
    fill: "#fddc85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.207,12.833,24,0,20.79,12.833a11.468,11.468,0,0,1,6.417,0Z",
    fill: "#fddc85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.79,35.166,24,48l3.208-12.834a11.444,11.444,0,0,1-6.417,0Z",
    fill: "#fddc85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.367,13.832,7.028,7.029l6.8,11.34A11.676,11.676,0,0,1,18.367,13.832Z",
    fill: "#fddc85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.631,34.167l11.339,6.8-6.8-11.338A11.684,11.684,0,0,1,29.631,34.167Z",
    fill: "#fddc85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.166,18.369l6.8-11.34-11.339,6.8A11.689,11.689,0,0,1,34.166,18.369Z",
    fill: "#fddc85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.832,29.632,7.028,40.97l11.339-6.8A11.671,11.671,0,0,1,13.832,29.632Z",
    fill: "#fddc85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.999,
    cy: 24,
    r: 9.375,
    fill: "#ffbd66"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.2de25e34169c71e8cf58b832b45922b4.svg";
export { ForwardRef as ReactComponent };